// removed by extract-text-webpack-plugin
module.exports = {"list":"_2Pkuq","item":"_1pa01","heading":"_2lA0c","button":"_2Vnbe","buttonActive":"_2OjGx _2Vnbe","match":"WzSzF","parentNotice":"IsTKi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/AutoComplete.css
// module id = 841
// module chunks = 0